<template lang="pug">
  v-dialog(v-model="dialog", width='800')
    v-card
      v-card-title.headline.primary.white--text(primary-title)
        | Usuário
      v-card-text
        u-form(v-model="result", :json="json", :resultJSON="true")
      v-divider
      v-card-actions
        v-spacer
        v-btn(color='default', flat, @click='dialog = false') {{ $t('words.cancel') }}
        v-btn(color='primary', @click='save()') {{ $t('words.save') }}
</template>

<script>
import UForm from '@/components/form/form'
import _ from 'lodash'

export default {
  name: 'user',

  components: {
    UForm
  },

  computed: {
  },

  props: {
    value: {
      type: Boolean
    },
    user: {
      type: Object
    }
  },

  watch: {
    value (val) {
      this.dialog = val
      if (!val) return
      this.result = {
        user: this.user
      }
    },
    dialog (val) {
      if (!val) this.result = {}
      this.$emit('input', val)
    }
  },

  data () {
    return {
      dialog: false,
      result: {},
      json: {
        label: 'User',
        type: 'panel',
        key: 'user',
        components: [
          {
            type: 'textfield',
            key: 'displayName',
            label: 'Nome',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'email',
            label: 'Email',
            style: 'xs12 sm4'
          },
          {
            'type': 'select',
            'key': 'role',
            'label': 'Perfil',
            'style': 'xs12 sm4',
            'items': [
              { 'text': 'Médico', 'value': 'doctor' },
              { 'text': 'Gerente', 'value': 'manager' },
              { 'text': 'Usuário', 'value': 'user' }
            ]
          },
          {
            type: 'textfield',
            key: 'crm',
            label: 'CRM',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'crmUF',
            label: 'CRM UF',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'cpf',
            label: 'CPF',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'externalUser',
            label: 'Id de integração',
            style: 'xs12 sm4'
          },
          {
            type: 'v-checkbox',
            key: 'schedule.activated',
            label: 'Agendamento',
            style: 'xs12 sm4'
          },
          {
            type: 'v-checkbox',
            key: 'enabledIA',
            label: 'Ativar IA',
            style: 'xs12 sm4'
          },
          {
            type: 'textarea',
            key: 'companiesStr',
            label: 'Empresas',
            style: 'xs12 sm12'
          },
          { type: 'divider' },
          {
            type: 'label',
            label: 'Alterar senha',
            style: 'xs12 sm12'
          },
          {
            type: 'textfield',
            inputType: 'password',
            key: 'password',
            label: 'Nova senha',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            inputType: 'password',
            key: 'passwordVerify',
            label: 'Confirmar nova senha',
            style: 'xs12 sm4'
          },
          {
            type: 'upload',
            key: 'signature',
            label: 'Assinatura',
            style: 'xs12 sm4',
            storageRef: 'signatures'
          },
          {
            type: 'textarea',
            key: 'complementaryInfo',
            label: 'Informações Complementares',
            style: 'xs12 sm12'
          }
        ]
      }
    }
  },

  methods: {
    async save () {
      let user = this.result.user

      // Autenticacao
      if (user.password) {
        if (user.password === user.passwordVerify) {
          user = _.omit(user, 'passwordVerify')
        } else {
          return window.alert('A senha não confere com a verificação.')
        }
      }

      user.companies = user.companiesStr.split(', ')
      user.companiesStr = null

      // Assinatura
      const compUploadFileImage = document.getElementById('user.signature').__vue__

      if (user.signature && user.signature.indexOf('data:') === 0) {
        try {
          this.$swal.fire({
            type: 'info',
            title: 'Fazendo upload da assinatura por favor aguarde',
            showCancelButton: false,
            showConfirmButton: false
          })
          user.signature = await compUploadFileImage.onUploadImage()
          this.$swal.fire({
            type: 'success',
            title: 'Assinatura salva',
            showCancelButton: false,
            showConfirmButton: true
          })
        } catch (e) {
          this.$swal.fire({
            type: 'warning',
            title: 'erro ao salvar a imagem da assinatura : ',
            text: e,
            showCancelButton: false,
            showConfirmButton: true
          })
        }
      }

      // Store save
      this.$store.dispatch('saveUser', user)
        .then(() => { this.dialog = false })
        .catch((err) => {
          console.error(err)
          return window.alert('Erro ao salvar usuário.')
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/User.vue